import type { Email, EmailShipment, FTLShipment, LTLShipment } from "@src/types/api";
import { shipmentUiBucketFromUnifiedDoc } from "@shared/utils/shipmentUiBucket";

export function emailShipmentsFtl(email: Email | null | undefined): FTLShipment[] {
  if (!email?.shipments?.length) return [];
  return email.shipments.filter(
    (s): s is FTLShipment => shipmentUiBucketFromUnifiedDoc(s) === "FTL"
  );
}
export function emailShipmentsLtl(email: Email | null | undefined): LTLShipment[] {
  if (!email?.shipments?.length) return [];
  return email.shipments.filter(
    (s): s is LTLShipment => shipmentUiBucketFromUnifiedDoc(s) === "LTL"
  );
}
export function emailWithShipmentPatched(email: Email, shipment: EmailShipment): Email {
  const list = [...(email.shipments ?? [])];
  const idx = list.findIndex((s) => s.shipmentId === shipment.shipmentId);

  if (idx >= 0) list[idx] = shipment;
  else list.push(shipment);
  return { ...email, shipments: list };
}
